import { Component, EventEmitter, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UbiFilterService } from '../../../theme';

import { DynamicGridComponent } from '../../../dynamic-entity/components/dynamic-grid/dynamic-grid.component';

import { ApiService, MetadataService, ExpressionFilter, ExpressionRule, Operator, Condition } from '../../../ubi-core/ubi-core.module';

@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcement.component.scss']
})
export class AnnouncementsComponent extends DynamicGridComponent implements OnInit {

  @ViewChild('hdrTpl') hdrTpl: TemplateRef<any>;
  @ViewChild('statusTmpl') statusTmpl: TemplateRef<any>;

  protected columns = [];

  constructor(protected baseservice: ApiService, protected metadataservice: MetadataService,
    protected router: Router, protected route: ActivatedRoute, protected modalService: NgbModal,
    protected filterservice: UbiFilterService) {

    super(baseservice, metadataservice, router, route, modalService, filterservice);

  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected getMetadata() {

    this.columns = [
      {
             prop: 'StatusID', name: 'Estado', width: 49, canAutoResize: false, draggable: false,
             resizeable: false, headerTemplate: this.hdrTpl, cellTemplate: this.statusTmpl
      },
      { prop: 'Id', name: 'Id' },
      { prop: 'Type.Designation', name: 'Tipo' },
      { prop: 'SeaportCustomer.Designation', name: 'Cliente' },
      { prop: 'Customer.Designation', name: 'Expedidor' },
      { prop: 'VesselAndProcess.Designation', name: 'Navio' },
      { prop: 'VesselAndProcess.Process', name: 'Contramarca' },
      { prop: 'PortOfLoading', name: 'Porto de Carga' },
      { prop: 'PortOfDischarge', name: 'Porto de Descarga' }      
    ];

    this.columns = [...this.columns];
  }

  protected getInitialData() {

    this.page.sorts = [{ prop: 'Id', dir: 'desc' }];

    this.getPage({ offset: 0 }, this.filter);
  }

  protected newClick(event) {
    this.router.navigateByUrl('backoffice/announcement');
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/backoffice/announcements/announcements.component.ts